import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import joinWords, { joinWordsAsSnippets } from 'cio/utils/join-words';
import { IntegrationSnippetType } from 'cio/utils/analytics/transforms/integrations';
import { FRAGMENT_QUERY } from 'cio/modifiers/scroll-to-fragment';

import ArrayProxy from '@ember/array/proxy';
import ApiCredentialModel from 'cio/models/api-credential';
import AnalyticsService from 'cio/services/analytics';
import ApiCredentialsService from 'cio/services/api-credentials';
import EnvironmentService from 'cio/services/environment';

export default class CustomerioController extends Controller {
  @service analytics!: AnalyticsService;
  @service apiCredentials!: ApiCredentialsService;
  @service environment!: EnvironmentService;

  queryParams = [FRAGMENT_QUERY];

  @tracked selectedCredential: ApiCredentialModel | null = null;

  @alias('apiCredentials.singleCredential') singleCredential!: boolean;
  @alias('apiCredentials.credentials') credentials!: ArrayProxy<ApiCredentialModel>;

  @computed('environment.current.allEnabledIdentifiers.[]')
  get identifierSnippets() {
    return joinWordsAsSnippets(this.environment.current.allEnabledIdentifiers);
  }

  @computed('environment.current.allEnabledIdentifiers.[]')
  get multiIdUsageComment() {
    let { allEnabledIdentifiers } = this.environment.current;

    return `Use ${allEnabledIdentifiers.length > 1 ? 'either ' : ''}${joinWords(allEnabledIdentifiers, ', ', ' or ')}.`;
  }

  @action
  onCopy(type: IntegrationSnippetType) {
    this.analytics.track('integration', 'api_credentials_copied', {
      credentialType: 'JavaScript',
      credentialCopied: type === 'js_snippet' ? 'JS Snippet' : 'JS Identify',
      source: 'Integration Page (C.io API)',
    });
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'integrations/customerio': CustomerioController;
  }
}
